import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { API_BASE } from '../apiConfig';

const API = API_BASE;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setAuthUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const exchangeSession = async (sessionId) => {
      const response = await fetch(`${API}/auth/session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sessionId })
      });
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.detail || `Server error (${response.status})`);
      }
      return response.json();
    };

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        navigate('/login', { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      let lastError;
      for (let attempt = 1; attempt <= 2; attempt++) {
        try {
          if (attempt > 1) await new Promise(r => setTimeout(r, 1500));
          
          const userData = await exchangeSession(sessionId);
          
          if (userData.session_token) {
            localStorage.setItem('reliefify_session_token', userData.session_token);
          }
          setAuthUser(userData);
          
          window.history.replaceState(null, '', '/select-school');
          navigate('/app/select-school', { replace: true, state: { user: userData } });
          return;
        } catch (error) {
          lastError = error;
          console.error(`Auth attempt ${attempt} failed:`, error.message);
        }
      }

      navigate('/login', { replace: true, state: { error: lastError?.message || 'Sign-in failed. Please try again.' } });
    };

    processAuth();
  }, [navigate, setAuthUser]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-teal-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600">Signing you in...</p>
      </div>
    </div>
  );
};
